import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { SERVER_URL } from './ServerConfig'

class Profile extends Component {

    notify = () => {
        toast.success("You profile settings has been updated!", {
            position: toast.POSITION.TOP_CENTER
        });
    };

    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleFirstNameChange = this.handleFirstNameChange.bind(this);
        this.handleLastNameChange = this.handleLastNameChange.bind(this);
        this.handlePhoneChange = this.handlePhoneChange.bind(this);

        this.state = {
            user: this.props.user.payload.user
        }
    }

    handleSubmit(event) {
        event.preventDefault();

        let body = {
            firstName: this.state.user.mFirstName,
            lastName: this.state.user.mLastName,
            phone: this.state.user.mPhone
        };
        fetch(SERVER_URL + '/v1/users/' + this.state.user._id + '/update', {
            method: 'post',
            headers: {
                'x-access-token': this.props.user.payload.token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        }).then(response => {
            if (response.status === 403) {
                this.props.history.push("/login");
            } else {
                return response.json();
            }
        })
            .then(data => {
                if (data.success) {
                    this.props.updateUserProfile(data.content);
                    this.notify();
                }

            });
    }

    handleFirstNameChange(event) {
        let user = this.state.user;
        user.mFirstName = event.target.value;
        this.setState({ user: user });
    }

    handleLastNameChange(event) {
        let user = this.state.user;
        user.mLastName = event.target.value;
        this.setState({ user: user });
    }

    handlePhoneChange(event) {
        let user = this.state.user;
        user.mPhone = event.target.value;
        this.setState({ user: user });
    }

    getAccountRole() {
        let user = this.state.user;
        if (user.member.mRole === 'owner') {
            return "Owner";
        }
        return "Member";
    }

    render() {
        return (
            <div className="main-content">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Profile</h1>
                            </div>
                        </div>
                    </div>
                </section>
                <div className="m-2">
                    <section className="content col-sm-9">
                        <div className="card">
                            <div className="card-body">
                                <form className="form-horizontal" onSubmit={this.handleSubmit}>
                                    <div className="form-group row">
                                        <label className="col-sm-2 col-form-label">Account Role</label>
                                        <div className="col-sm-10">
                                            <input type="text" className="form-control-plaintext" placeholder=""
                                                value={this.getAccountRole()} readOnly />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-2 col-form-label">Email</label>
                                        <div className="col-sm-10">
                                            <input type="email" className="form-control-plaintext" placeholder="Email"
                                                value={this.state.user.mEmail} readOnly />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-2 col-form-label">First Name</label>
                                        <div className="col-sm-10">
                                            <input type="text" className="form-control"
                                                value={this.state.user.mFirstName} onChange={this.handleFirstNameChange} />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-2 col-form-label">Last Name</label>
                                        <div className="col-sm-10">
                                            <input type="text" className="form-control"
                                                value={this.state.user.mLastName} onChange={this.handleLastNameChange} />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-2 col-form-label">Phone</label>
                                        <div className="col-sm-10">
                                            <input type="text" className="form-control"
                                                value={this.state.user.mPhone} onChange={this.handlePhoneChange} />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="offset-sm-2 col-sm-10">
                                            <button type="submit" className="btn btn-primary">Update</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>

                    </section>

                </div >
                <ToastContainer />
            </div >

        );

    }
}

export default Profile;